<div class="container radius-0">
  <h2 class="mb-2 text-sm font-normal text-n-40">{{ 'paymentMethodTitle' | commonPaymentWording | async }}</h2>
  <div class="row mb-[16px]" *ngIf="connectedPaymentMethod$ | async as connectedPaymentMethod">
    <div class="col-12">
      <yat-payment-method-panel
        id="5698be30-1eeb-4f8a-9308-dbce7bf3606b"
        [paymentMethod]="connectedPaymentMethod"
        defaultIcon="settings"
        [showDeleteIcon]="false"
        [showEditIcon]="false"
        [minified]="true"
        [liveLicense]="(isLive$ | async) ?? true"
        (selectMethod)="managePaymentMethod()"
        matomoEventClickAction="Modify_PaymentMethod">
      </yat-payment-method-panel>
    </div>
  </div>
  <h2 class="mb-2 text-sm font-normal text-n-40" *ngIf="(billingAddressRequired$ | async) || (selectedBillingAddress$ | async) !== null">
    {{ 'billingAddressTitle' | commonBillingWording | async }}
    <yat-tooltip-info-icon
      iconClass="ml-1"
      tooltipClass="tooltip-xl"
      [tooltipContent]="'subscriptionManagement.updateConfirmation.billingInformationTooltip' | transloco">
    </yat-tooltip-info-icon>
  </h2>
  <ng-container *ngIf="selectedBillingAddress$ | async as selectedBillingAddress; else noBillingAddressSelected">
    <div class="row">
      <div class="col-12">
        <yat-billing-address-panel
          id="d8386382-c63f-4f90-b340-176eeca7701c"
          [billingAddress]="selectedBillingAddress"
          defaultIcon="settings"
          [showDeleteIcon]="false"
          [showEditIcon]="false"
          [liveLicense]="(isLive$ | async) ?? true"
          [minified]="true"
          (selectAddress)="manageBillingAddress()"
          matomoEventClickAction="Modify_BillingAddress">
        </yat-billing-address-panel>
      </div>
    </div>
  </ng-container>
  <ng-template #noBillingAddressSelected>
    <div class="row">
      <div class="col-12">
        <yat-no-billing-address-selected-panel
          id="3ab5195a-9dfe-400e-89b7-1ec44934bbd7"
          [billingAddressRequired]="billingAddressRequired$ | async"
          (createFirstAddress)="createBillingAddress()"
          (selectExistingAddress)="manageBillingAddress()">
        </yat-no-billing-address-selected-panel>
      </div>
    </div>
  </ng-template>
</div>

<div class="container complete-purchase" *ngIf="licenseType$ | async as licenseType">
  <ng-container *yatVar="fixedFulfillmentCountry$ | async as fixedFulfillmentCountry">
    <div class="row">
      <div class="col-8">
        <yat-country-selector
          id="bbe60694-dc6f-435c-b720-5bb9115fca40"
          *ngIf="!fixedFulfillmentCountry"
          [countries]="(countries$ | async) ?? []"
          [selectedCountry]="selectedCountry$ | async"
          [disableSelection]="(selectedBillingAddress$ | async) !== null"
          (countryChanged)="updateCountryForNoBillingAddressSelection($event)">
        </yat-country-selector>
      </div>
      <div class="col-4 text-right">
        <yat-license-type-selector id="34dca71e-9b33-45ac-8f4c-f6ebe1b205d8" [selectedLicenseType]="licenseType$ | async" [disableSelection]="true">
        </yat-license-type-selector>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-12">
        <div class="border-dotted d-block pb-1 mt-1"></div>
      </div>
    </div>
    <yat-price-overview
      id="3fc9b2c1-2b1d-4408-8471-e19d0a630924"
      [pricingInformation]="selectedPricingInformation$ | async"
      [hideTooltip]="fixedFulfillmentCountry">
    </yat-price-overview>
    <div class="mbottom-12">
      <yat-buttons
        [primaryButtonName]="'subscriptionManagement.updateConfirmation.confirmChanges' | transloco"
        [secondaryButtonName]="('cancel' | commonWording | async) ?? ''"
        [disablePrimaryButton]="!!((billingAddressRequired$ | async) && (selectedBillingAddress$ | async) === null)"
        (primaryButtonClickMethod)="tryConfirm()"
        (secondaryButtonClickMethod)="cancel()"
        [useYatAutoSpinner]="updateActionFilter"
        [matomoEventCategory]="MATOMO_EVENT_CATEGORY_BILLING"
        matomoEventClickPrimaryButtonAction="ConfirmChanges"
        matomoEventClickSecondaryButtonAction="Cancel"
        matomoEventName="Confirm_ChangeBillingAddress">
      </yat-buttons>
    </div>
    <ng-container *ngIf="subscriptionDetails$ | async as subscriptionDetails">
      <div class="row" *ngIf="outstandingTransactions$ | async">
        <div class="col-12 text-center">
          <transloco
            id="f721bcc7-ae62-4d17-8133-8e21603a4f58"
            [key]="
              subscriptionDetails.bookingStatus === 'BOOKED'
                ? 'subscriptionManagement.updateConfirmation.firstPaymentOn'
                : 'subscriptionManagement.updateConfirmation.nextPaymentOn'
            "
            [params]="{
              endOfPeriod: subscriptionDetails.endOfPeriod | translocoDate
            }"></transloco>
        </div>
      </div>
    </ng-container>
    <div class="row" *yatVar="productLocalization$ | async as productLocalization">
      <div class="col-12">
        <p class="text-center font-small mt-1">
          <transloco
            id="be5f2d3f-851a-4e99-8a24-a6609a88694e"
            key="subscriptionManagement.updateConfirmation.agreeToTerms"
            [params]="{
              name: (productCategory$ | async) === 'TRAVEL_TICKET' ? (vendorName$ | async) : (productName$ | async),
              termsLink: { url: productLocalization?.termsPath ?? '', class: 'c-gray underline', target: '_blank', id: 'b99503a9-0c9b-495d-a7a5-19265bad8725' },
              privacyPolicyLink: {
                url: productLocalization?.privacyPolicyPath ?? '',
                class: 'c-gray underline',
                target: '_blank',
                id: 'e7364a0d-b536-4d09-84a4-76362ddddfa5'
              },
              productCategory: (productCategory$ | async)
            }">
          </transloco>
        </p>
      </div>
    </div>
  </ng-container>
</div>
